var map = {
	"./active_tab_bg.png": "bd74",
	"./default_tab_bg.png": "4dab",
	"./game_icon.png": "0374",
	"./game_icon_1.png": "eccd",
	"./game_item_bg.png": "ac62",
	"./game_rank_rule.png": "08fb",
	"./game_signin_bg.png": "165a",
	"./header.png": "78b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d784b";